module.exports = {"pathContext":{"group":[{"node":{"excerpt":"\nLast week I decided to finally transition my current blog over to GatsbyJS. Because I wanted to generally just revamp the blog both content-wise and performance-wise.\n\n","frontmatter":{"title":"Welcome to My New Blog","path":"/my-new-blog/","date":"August 9, 2018"}}}],"pathPrefix":"","first":true,"last":true,"index":1,"pageCount":1,"additionalContext":{}}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 376
// module chunks = 142629428675168